var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notFound"},[_c('div',{staticClass:"notfoundbg"},[_c('img',{attrs:{"src":require("../../public/imgs/405.png"),"alt":""}}),_c('div',{staticClass:"nofoundtxt"},[_vm._v("很抱歉，页面它不小心迷路了~")]),_c('div',{staticClass:"goback cursor",on:{"click":_vm.gohome}},[_vm._v("返回首页")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }